import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable, map, startWith } from 'rxjs';
import { ContactResponse, PreferredContactMethod } from '../../../models/contact.model';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { RouterLink } from '@angular/router';
import { MAT_RADIO_DEFAULT_OPTIONS, MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ContactNewDialogComponent } from '../../contacts/contact-new-dialog/contact-new-dialog.component';
import { ContactSearchDialogComponent } from '../../contacts/contact-search-dialog/contact-search-dialog.component';
import { AnimalTypeResponse } from '../../../models/animalType.model';
import { LocationResponse } from '../../../models/location.model';
import { ClinicResponse } from '../../../models/clinic.model';
import { CremationType, OrderResponse, OrderStatusResponse, OrderStatusWithRequirementResponse, TransitionRequirement, UpdateOrderRequest } from '../../../models/orders/order.model';
import { OrderService } from '../../../services/order.service';
import { CreateCommunicationLogRequest } from '../../../models/orders/communicationLog.model';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { StatusDialogComponent } from '../status-dialog/status-dialog.component';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { QRCodeModule } from 'angularx-qrcode';
import { ChangeSingleOrderStatusComponent } from '../change-single-order-status/change-single-order-status.component';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { OrderCommunicationIndexComponent } from '../order-communication-index/order-communication-index.component';
import { ToastrService } from 'ngx-toastr';
import { LocationService } from '../../../services/location.service';
import { ClinicService } from '../../../services/clinic.service';
import { ContactService } from '../../../services/contact.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommunicationTypes } from '../../../helpers/communicationTypes';
import { CommunicationLogsService } from '../../../services/communication-logs.service';
import { AuthService, roles } from '../../../services/auth.service';
import { expand } from '../../../../assets/animations';
import { SearchLocationComponent } from '../../locations/search-location/search-location.component';
import { generateOrderTag } from '../../../helpers/pdfHelpers';
import { OrderSchedulesIndexComponent } from '../order-schedules-index/order-schedules-index.component';
import { FlowChartComponent } from '../../flow-chart/flow-chart.component';

@Component({
  selector: 'app-order-edit',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatGridListModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDivider,
    RouterLink,
    MatRadioModule,
    MatIconModule,
    MatDialogModule,
    MatTableModule,
    QRCodeModule,
    MatListModule,
    MatProgressSpinnerModule,
    ChangeSingleOrderStatusComponent,
    OrderCommunicationIndexComponent,
    SearchLocationComponent,
    OrderSchedulesIndexComponent,
    FlowChartComponent,
  ],
  templateUrl: './order-edit.component.html',
  styleUrl: './order-edit.component.scss',
  providers: [{
    provide: MAT_RADIO_DEFAULT_OPTIONS,
    useValue: { color: 'primary' },
  },DecimalPipe],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px', // Collapsed height
        opacity: 0,
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',  // Expanded to full height
        opacity: 1,
        overflow: 'hidden'
      })),
      transition('collapsed => expanded', [
        animate('300ms ease-out')
      ]),
      transition('expanded => collapsed', [
        animate('300ms ease-in')
      ])
    ]),expand
  ]
})

export class OrderEditComponent implements OnInit {
  @Input() orderRefFromTable!: string;
  @Output() orderUpdated = new EventEmitter<void>();

  isFormDisabled:boolean = false

  order!: OrderResponse;
  form!: FormGroup;
  savingOrder: boolean = false;
  addingContact: boolean = false;
  searchingContact: boolean = false;
  selectedContacts: ContactResponse[] = [];

  clinicControl = new FormControl<string | ClinicResponse>('');
  pickUpControl = new FormControl<LocationResponse | null>(null);
  dropOffControl = new FormControl<LocationResponse | null>(null);
  clinicFilteredOptions!: Observable<ClinicResponse[]>;
  pickUpFilteredOptions!: Observable<LocationResponse[]>;
  dropOffFilteredOptions!: Observable<LocationResponse[]>;

  private _pickupType!:string;

  get pickupType(): string {
    return this._pickupType;
  }

  set pickupType(value:string) {
    this._pickupType = value;
    if(this._pickupType == 'clinic')
    {
      this.form.controls['pickUpFromClinic'].setValue(true);
      this.onPickupClinicSelected();
    }
    else
    {
      this.form.controls['pickUpFromClinic'].setValue(false);
    }

  }

  private _dropoffType!:string;
  get dropoffType(): string {
    return this._dropoffType;
  }

  set dropoffType(value:string) {
    this._dropoffType = value;
    if(this._dropoffType == 'clinic')
    {
      this.form.controls['dropOffToClinic'].setValue(true);
      this.onDropoffClinicSelected();
    }
    else
    {
      this.form.controls['dropOffToClinic'].setValue(false);
    }
  }


  communicationForm!: FormGroup;

  //mock up data
  orders: OrderResponse[] = [];
  clinics: ClinicResponse[] = [];
  locations: LocationResponse[] = [];
  contacts: ContactResponse[] = [];
  animalTypes: AnimalTypeResponse[] = [];
  statuses: OrderStatusResponse[] = [];

  cremationTypes = Object.values(CremationType);
  contactMethods = Object.values(PreferredContactMethod);

  //ComLogs
  @ViewChild(OrderCommunicationIndexComponent) communicationLog!: OrderCommunicationIndexComponent;
  isExpanded:boolean = false;
  communicationTypesKeys = Object.keys(CommunicationTypes)
  communicationTypes = Object.values(CommunicationTypes).filter(key => isNaN(Number(key)));
  
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private orderService: OrderService,
    private clinicService: ClinicService,
    private locationService: LocationService,
    private toastr: ToastrService,
    private contactService: ContactService,
    private decimalPipe: DecimalPipe,
    private communicationService: CommunicationLogsService,
    private loginService: AuthService,
  ) { }

  ngOnInit(): void {

    this.getData();
    if (this.orderRefFromTable) {
      this.getOrder(this.orderRefFromTable);
    } else {
      this.route.paramMap.subscribe(params => {
        const orderReference = params.get('ref');
        if (orderReference) {
          this.getOrder(orderReference);
        }
      })
    }

  }
  initForm()
  {
    this.form = this.fb.group({
      clinicId: ['', Validators.required],
      status: ['',],
      cremationType: ['', Validators.required],
      weight: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.min(0.01)]],
      pickUpLocationId: ['', Validators.required],
      pickUpFromClinic: [true],
      dropOffLocationId: ['', Validators.required],
      dropOffToClinic: [true],
      contactId: [''],
      animalName: ['', Validators.required],
      animalTypeId: ['', Validators.required],
      specialInstructions: [''],
      contacts: this.fb.array([], Validators.required),
      primaryContactId: [''],
      communicationLog: this.fb.array([]),
      // createdBy: [''], //timestamp
    });

    //communicateForm
    this.communicationForm = new FormGroup({
      note: new FormControl('', Validators.required),
      communicationType: new FormControl('', Validators.required),
      contactId: new FormControl('', Validators.required),
    });

    this.loginService.claims$.subscribe((c) => {
      const role = c['extension_Role'];
      if(role == roles.clinicstaff)
        {
          this.toggleForm()
        }
    });
  }
  toggleForm()
  {
    this.isFormDisabled = !this.isFormDisabled
    this.form.disabled ? this.form.enable() :  this.form.disable();
    this.communicationForm.disabled ? this.communicationForm.enable() :  this.communicationForm.disable();
    this.clinicControl.disabled ? this.clinicControl.enable() :  this.clinicControl.disable();
    this.pickUpControl.disabled ? this.pickUpControl.enable() :  this.pickUpControl.disable();
    this.dropOffControl.disabled ? this.dropOffControl.enable() :  this.dropOffControl.disable();
  }

  getOrder(ref: string) {
    this.orderService.getOrderByReference(ref).subscribe({
      next: (res) => {
        this.order = res;
        this.contacts = res.contacts
        this.patchOrderData(this.order);
        this.pickUpControl.setValue(this.order.pickupLocation);
        this.dropOffControl.setValue(this.order.dropOffLocation);
        this.clinicControl.setValue(this.order.clinic);
      },
      error: (error) => {
        this.toastr.error(error.error?.title || 'An error occurred');
      }
    })
    this.initForm();
  }

  //get other data
  getData() {
    this.clinicService.getClinics().subscribe({
      next: (result) => {
        this.clinics = result.clinics;
        this.setFilteredClinics();
      },
      error: (error) => {
        this.toastr.error(error.error?.title || 'An error occurred when getting the clinics. Please try again.');
      }
    });

    this.orderService.getAnimalTypes().subscribe({
      next: (result) => {
        this.animalTypes = result.items;
      },
      error: (error) => {
        this.toastr.error(error.error?.title || 'An error occurred when getting the animalTypes. Please try again.');
      }
    });

    this.orderService.getOrderStatuses().subscribe({
      next: (result) => {
        this.statuses = result.items;
      },
      error: (error) => {
        this.toastr.error(error.error?.title || 'An error occurred when getting the order statuses. Please try again.');
      }
    })
  }
  patchOrderData(order: OrderResponse) {
    this.form.patchValue({
      clinicId: order.clinic.id,
      weight: order.weight,
      cremationType: order.cremationType,
      pickUpLocationId: order.pickupLocation.id,
      pickUpFromClinic: order.pickupFromClinic,
      dropOffLocationId: order.dropOffLocation.id,
      dropOffToClinic: order.dropOffToClinic,
      animalName: order.animalName,
      animalTypeId: order.animalType.id,
      specialInstructions: order.specialInstructions,
      primaryContactId: order.primaryContactId,
      status: order.status ? order.status.id : null,
    });
    this.patchContacts(order.contacts, order.primaryContactId);
  }

  patchContacts(contacts: ContactResponse[], primaryContactId: string) {
    const contactFormGroups = contacts.map(contact =>
      this.createContactFormGroup(contact, contact.id === primaryContactId)
    );
    this.contactsArray.clear();
    contactFormGroups.forEach(contactFormGroup => {
      this.contactsArray.push(contactFormGroup);
    });
  }

  createContactFormGroup(contact: ContactResponse, isPrimary: boolean): FormGroup {
    const contactFormGroup = this.fb.group({
      contact: this.fb.group({
        id: [contact.id],
        firstName: [contact.firstName, Validators.required],
        lastName: [contact.lastName, Validators.required],
        email: [contact.email, Validators.email],
        phone: [contact.phone],
        PreferredContactMethod: [contact.preferredContactMethod, Validators.required],
        note: [contact.note]
      }),
      isPrimary: [isPrimary]
    });
    return contactFormGroup;
  }

  //communication logs

  addCommunicationLog() {
    if (this.communicationForm.valid) {
      const newLog: CreateCommunicationLogRequest = {
        orderId: this.order.id,
        contactId: this.communicationForm.value.contactId.id,
        communicationType: this.communicationForm.value.communicationType,
        note: this.communicationForm.value.note

      };
      this.communicationService.createCommunicationLogForOrder(this.order.id,newLog).subscribe(
        {
          next: (res) => {
            this.communicationLog.getData();
            this.toastr.success('Communication Log Created Succesfully')
          },
          error: (error) => {
            this.toastr.error('Something went wrong creating communication log:' + error.message)
          }
        }

      );

      this.communicationForm.reset();
      Object.keys(this.communicationForm.controls).forEach(key => {
        this.communicationForm.controls[key].setErrors(null);
        this.communicationForm.controls[key].markAsPristine();
        this.communicationForm.controls[key].markAsUntouched();
      })
    }
  }

  setFilteredClinics() {
    this.clinicFilteredOptions = this.clinicControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this.clinicFilter(name as string) : this.clinics.slice();
      }),
    );
  }


  private clinicFilter(name: string): ClinicResponse[] {
    const filterValue = name.toLowerCase();
    return this.clinics.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  displayClinicFn(clinic: ClinicResponse): string {
    return clinic && clinic.name ? clinic.name : '';
  }

  displayLocationFn(location: LocationResponse): string {
    return location && location.name ? location.name : '';
  }

  generateQrLink(reference: string) {
    return window.location.origin + `/orders/${reference}`;
  }

  onSelectionClinic(clinic: ClinicResponse) {
    this.form.patchValue({
      clinicId: clinic.id,
    });

    const defaultLocation = this.locations.find(location => location.id == clinic.defaultLocationId);
    if (defaultLocation) {
      this.pickUpControl.setValue(defaultLocation);
      this.dropOffControl.setValue(defaultLocation);
      this.pickupType = 'clinic';
      this.dropoffType = 'clinic';
    }
  }

  clearPickUp()
  {
    this.pickUpControl.setValue(null)
  }

  clearDropOff()
  {
    this.dropOffControl.setValue(null)
  }

  onPickupClinicSelected()
  {
    this.locationService.getLocation(this.order.clinic.defaultLocationId).subscribe({
      next: (res) => {
        this.pickUpControl.setValue(res);
        this.onSelectionPickUp(res);
      },
      error: (error) => {
        this.toastr.error('Could not set clinic location. Please try reloading the page.');
      }
    });
  }

  onDropoffClinicSelected()
  {
    this.locationService.getLocation(this.order.clinic.defaultLocationId).subscribe({
      next: (res) => {
        this.dropOffControl.setValue(res);
        this.onSelectionDropOff(res);
      },
      error: (error) => {
        this.toastr.error('Could not set clinic location. Please try reloading the page.');
      }
    });
  }

  onSelectionPickUp(location: LocationResponse) {
    this.form.patchValue({
      pickUpLocationId: location.id,
    });
    this.pickUpControl.setValue(location);
  }

  onSelectionDropOff(location: LocationResponse) {
    this.form.patchValue({
      dropOffLocationId: location.id,
    });
    this.dropOffControl.setValue(location);
  }

  get contactsArray() {
    return this.form.get('contacts') as FormArray;
  }

  addContact(contact: ContactResponse) {
    const contactFormGroup = this.fb.group({
      contact: this.fb.group({
        id: [contact.id],
        firstName: [contact.firstName, Validators.required],
        lastName: [contact.lastName, Validators.required],
        email: [contact.email, Validators.email],
        phone: [contact.phone],
        PreferredContactMethod: [contact.preferredContactMethod, Validators.required],
        note: [contact.note]
      }),
      isPrimary: [this.contactsArray.length === 0] // Automatically set the first contact as primary
    });
    this.contactsArray.push(contactFormGroup);
  }

  removeContact(index: number) {
    const wasPrimary = this.contactsArray.at(index).get('isPrimary');
    this.contactsArray.removeAt(index);

    if (wasPrimary && this.contactsArray.length > 0) {
      let anotherPrimaryExists = this.contactsArray.controls.some(c => c.value.isPrimary === true);

      if (!anotherPrimaryExists)
        this.contactsArray.at(0).get('isPrimary')?.setValue(true);
    }
  }

  setPrimary(index: number) {
    this.contactsArray.controls.forEach((control, i) => {
      control.get('isPrimary')?.setValue(i === index);
    })
  }

  onSubmit(event: Event) {
    event.preventDefault();
    const contactIds = this.contactsArray.controls.map(c => c.value.contact.id);
    const primaryContact = this.contactsArray.controls.find(c => c.value.isPrimary === true)?.value.contact;

    if (this.form.valid && primaryContact) {
      this.savingOrder = true;

      //create a new form Data and patch the contactIds and primaryId
      this.form.get('primaryContactId')?.patchValue(primaryContact.id);
      const order: UpdateOrderRequest = {
        clinicId: this.form.value.clinicId,
        cremationType: this.form.value.cremationType,
        weight: this.form.value.weight,
        pickUpLocationId: this.form.value.pickUpLocationId,
        pickUpFromClinic: this.form.value.pickUpFromClinic,
        dropOffLocationId: this.form.value.dropOffLocationId,
        dropOffToClinic: this.form.value.dropOffToClinic,
        primaryContactId: this.form.value.primaryContactId,
        contactIds: contactIds,
        animalName: this.form.value.animalName,
        animalTypeId: this.form.value.animalTypeId,
        specialInstructions: this.form.value.specialInstructions,
        communicationLog: this.form.value.communicationLog,
        packageIds: this.form.value.packageIds,
        productIds: this.form.value.productIds,
      }

      this.orderService.updateOrder(this.order.id, order).subscribe({
        next: (res) => {
          this.toastr.success('Order updated successfully.');
          this.getOrder(this.order.referenceNumber.toString());
          this.orderUpdated.emit();
          this.savingOrder = false;
        },
        error: (error) => {
          this.savingOrder = false;
          this.toastr.error(error.error?.title || 'An error occurred when updating the order. Please try again.');
        }
      });

      //TODO: add communication logs etc

    } else {
      this.toastr.error('Validation errors, make sure you fill out all required ');
    }
  }

  //dialogs
  openAddContactDialog() {
    const dialogRef = this.dialog.open(ContactNewDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.contactService.createContact(result).subscribe({
          next: (res) => {
            this.toastr.success('Contact created successfully.');
            this.addContact(res);
          },
          error: (error) => {
            this.toastr.error(error.error?.title || 'An error occurred. Please try again.');
          }
        });
      }
    })
  }

  openUpdateStatusDialog() {
    const dialogRef = this.dialog.open(ChangeSingleOrderStatusComponent, {
      width: '500px',
      data: { order: this.order }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.orderRefFromTable) {
          this.getOrder(this.orderRefFromTable);
        } else {
          this.route.paramMap.subscribe(params => {
            const orderReference = params.get('ref');
            if (orderReference) {
              this.getOrder(orderReference);
              this.orderUpdated.emit();
            }
          })
        }
      }
    });
  }


  openSearchContactDialog() {
    const dialogRef = this.dialog.open(ContactSearchDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (!this.contactsArray.controls.some(c => c.get('contact')?.get('id')?.value === result.id)) {
          this.addContact(result);
        } else {
          this.toastr.error('This contact exists, cannot add it twice');
        }
      }
    })
  }


  generateFlowChartString(order: OrderResponse): string {
    var statuses = this.statuses;
    var jstext = "graph TD\n";
    const currentStatusId = order.status.id; // Get the current statusId
    let style = "";
  
    for (let status of statuses) {
      let nodeStyle = "";
      if (status.id === currentStatusId) {
        style +=`style ${status.id} fill:#8ac220,color:#000\n`; // Light green fill
      }
      let newLine = `${status.id}[${status.name}]\n`; // Add style if needed
      jstext += newLine;
    }
  
    jstext += "\n";
    for (let status of statuses) {
      if (status.validTransitions) {
        for (let targetId of status.validTransitions) {
          let transitionLine = `${status.id} --> ${targetId}\n`;
          jstext += transitionLine;
        }
      }
    }
    jstext += style;
    return jstext;
  }

  openFlowChartDialog() {
    const chartData = this.generateFlowChartString(this.order);
    const dialogRef = this.dialog.open(FlowChartComponent, {
      width: '90%',
      data: chartData
    });
  }


  generateOrderTag(order: OrderResponse) {
    generateOrderTag(order);
  }
  
  onDeselect()
  {
    const value = this.form.value.weight
    const formatted = this.decimalPipe.transform(value, '1.2-2')
    this.form.patchValue({weight:formatted})
  }
  toggleCard(event: Event) {
    event.preventDefault();
    setTimeout(() => {
      this.isExpanded = !this.isExpanded;
    }, 0);
  }

  getState() {
    return this.isExpanded ? 'expanded' : 'collapsed';
  }
}
